<template>
    <v-form v-model="is_valid"
            :disabled="loading">
        <v-container class="base container-fuid">
            <h1>Reinicializar a autenticação via aplicativo</h1>
            <v-row>
                <v-col>
                    <strong>
                        Se você reinicializar as informações de autenticação
                        a entrada no sistema será impossível até você
                        <router-link to="./enable-2fa">
                            reconfigurar o acesso via aplicativo
                        </router-link>. Este processo desabilita o acesso
                        via aplicativo ao reinicializar o estado de configuração,
                        permitindo que você refaça o processo de configuração.
                    </strong>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn @click="reset">Reinicializar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
</style>

<script lang="js">
import ApiService from '@/services/ApiService';

export default          {
    data                () {
        return          {
            api         : undefined,
            is_valid    : false,
            loading     : false
        }
    },
    methods             : {
        async reset     () {
            try {
                this.loading = true;
                const resp = await this.api.mfaResetAuthenticator();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada ao reinicializar.');
                    return;
                }
                this.$toast.info('Reinicialização efetuada, redirecionando...');
                setTimeout(() => this.$router.push({ name: 'Enable2FA' }), 2000);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted             () {
        this.api = new ApiService();
    }
}
</script>